import * as React from "react";
const SvgCleanSanitizer = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.214 1.385a.75.75 0 1 0 0 1.5h1.75v1.5h-1.25a.75.75 0 0 0-.75.75V8.61l-3.567 1.31a1.75 1.75 0 0 0-1.147 1.643v9.301c0 .967.784 1.75 1.75 1.75h12a1.75 1.75 0 0 0 1.75-1.75v-9.284a1.75 1.75 0 0 0-1.186-1.656l-4.1-1.397V5.135a.75.75 0 0 0-.75-.75h-1.25v-1.5h2.25c.578 0 2.191.184 3.665.92a.75.75 0 0 0 .67-1.341c-1.726-.863-3.58-1.08-4.335-1.08h-5.5Zm4.5 8.5H9.892a.25.25 0 0 0-.086.015l-3.892 1.429a.25.25 0 0 0-.164.234v9.302c0 .138.112.25.25.25h12a.25.25 0 0 0 .25-.25v-9.284a.25.25 0 0 0-.17-.236l-4.246-1.447a.25.25 0 0 0-.081-.013h-.039Zm-.75-1.5v-2.5h-2.5v2.5h2.5Zm-1.25 4a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75h-1.75a.75.75 0 0 1 0-1.5h1.75v-1.75a.75.75 0 0 1 .75-.75Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCleanSanitizer;
